var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Footer"}},[_c('div',{staticClass:"end"},[_vm._v(" Copyright©  2019-"+_vm._s(_vm.DataYears)+"  印工社（青岛）数字科技有限公司 All Rights Reserved  |  鲁ICP备12040237号-2  鲁公网安备 44030502001025号 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }